var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content && _vm.content.length)?_c('div',{staticClass:"static-block-placement"},_vm._l((_vm.content),function(text,index){return _c('div',{key:index,staticClass:"static-block",domProps:{"innerHTML":_vm._s(text)}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }